import { jwtDecode } from "jwt-decode";

// Custom JWT claim emitted by the backend alongside the role claim; carries the
// user's granular permissions.
export const CLAIM_PERMISSION = "permission";

// Extract the permission list from a JWT. .NET serializes a single claim value
// as a bare string and multiple values as an array, so coerce to string[] for
// both shapes. Returns [] for a missing claim or an undecodable token.
export const getPermissionsFromToken = (token?: string | null): string[] => {
    if (!token) return [];
    try {
        const claims = jwtDecode<Record<string, unknown>>(token);
        const raw = claims[CLAIM_PERMISSION];
        if (Array.isArray(raw)) return raw as string[];
        if (typeof raw === "string") return [raw];
        return [];
    } catch {
        return [];
    }
};
